/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-unused-vars */
//types
import { DeleteOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Card, Col, Row, Space, Switch, Table } from 'antd';
import type { TablePaginationConfig } from 'antd/es/table';
import styled from 'styled-components';

import React from 'react';

import {
  ManageStoreCard, StoreCard
} from '@a4b/api/src/modules/Monetisation/offerings/types';

interface Props {
  onCreateNew: () => void
  onStatusChange: (storeCard: StoreCard) => void
  triggerEdit: (storeCard: StoreCard) => void
  triggerDelete: (storeCard: StoreCard) => void
  dataSource: ManageStoreCard[]
  rowSelectionConfig: any
  totalRecordsCount: number
  paginationParams: TablePaginationConfig
  handleTableChange: (paginationParams: TablePaginationConfig) => void
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex-grow: 1;
  }
`
const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`

const ManageStoreCardPage: React.FC<Props> = ({
  onCreateNew,
  triggerEdit,
  triggerDelete,
  dataSource,
  onStatusChange,
  totalRecordsCount,
  paginationParams,
  handleTableChange
}) => {
  const dataColumns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: '40%',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: '30%',
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      width: '30%',
    },
    {
      title: 'Action',
      key: 'action',
      width: '20%',
      render: (text: any, record: any, index: any) => {
        return (
          <Row style={{ width: 200 }}>
            <Col span={8}>
              <Switch
                checked={record.active}
                onChange={() => onStatusChange(record)}
              />
            </Col>
            <Col span={8}>
              <Button onClick={() => triggerEdit(record)} type='link'>Edit</Button>
            </Col>
            <Col span={8}>
              <Button danger onClick={() => triggerDelete(record)} ><DeleteOutlined /></Button>
            </Col>
          </Row>
        )
      },
    },
  ]
  return (
    <Container style={{ width: '100%' }}>
      <Space direction={'vertical'} style={{ width: '100%' }}></Space>
      <BodyContainer>
        <Button type='text' onClick={onCreateNew}>
          <PlusSquareOutlined /> Add New Store Card
        </Button>

        <Table
          style={{ width: "100%" }}
          //rowSelection={rowSelectionConfig}
          columns={dataColumns}
          dataSource={dataSource}
          pagination={paginationParams}
          onChange={handleTableChange}
        />
      </BodyContainer>
    </Container>
  )
}

export default ManageStoreCardPage
